export interface RealTimeConnectOptions {
	url: string;
	enableReconnect?: boolean;
	onDisconnect?: () => void;
	onReconnect?: () => void;
}

export const enum RealTimeError {
	NoSession = "Session is not active",
	AlreadyExists = "Session already exists",
}

export interface RealTimeMessageEvent<T> {
	message: T;
	channel: string;
}

export namespace RealTimeSelector {
	export const getCustomerId = (state: any): string | undefined => state.customer?.customer?.customerId;
}
